import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { formatTime, WorkTimeDetailsList } from "./workTimeDetailsList";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { customHistory } from "../../framework/customHistory";
import MuiSelect from "../framework/muiSelect";
import {
    generatePath,
    Redirect,
    RouteComponentProps,
    useParams,
} from "react-router-dom";
import { WorkHoursPerWeek } from "./workHoursPerWeek";
import { WorkHoursPerSalaryPeriod } from "./workHoursPerSalaryPeriod";
import { WorkTimeDetailsDayBookingList } from "./workTimeDetailsDayBookingList";
import { IWorkTimeDetailsPage } from "./workTimeBetaDetailsPageMain";
import { DayBookingItemBeta } from "../../models/dayBooking/dayBookingItemBeta";
import { useReload } from "../../hooks";
import { WorkTimeDetailsCalendar } from "./workTimeDetailsCalendar";
import { useAppDispatch } from "../../framework/customStore";
import { useAsyncThunkAction } from "../../hooks/useAsyncThunkAction";
import {
    fetchWorkTimeTypes,
    fetchSalaryRowTypes,
    selectSalaryRowTypes,
} from "../../store/workShiftTimeSlotSlice";
import { Base } from "../../framework/base";
import { handleApiError } from "../../models/store/storeEffects";
import { WorkTimeDetailsMap } from "./workTimeDetailsMap";
import { WorkTimeDetailsLayout } from "../layout/workTimeDetailsLayout";
import { WorkTimeTimeline } from "./workTimeTimeline";
import { getDayBookingItems } from "../../services/dayBookingService";
import * as storeActions from "../../models/store/storeActions";
import * as baseService from "../../services/baseService";
import { SalaryPeriodItem } from "../../models/salaryPeriod/salaryPeriodItem";
import {
    calculatedWorkHours,
    normalWorkHours,
} from "../../store/workHoursSlice";
import * as dayBookingTypeService from "../../services/dayBookingTypeService";
import { DayBookingTypeItemBeta } from "../../models/dayBookingType/dayBookingTypeItemBeta";
import * as store from "../../framework/customStore";
import { DayAllowanceSelect } from "./dayAllowanceSelect";
import { PrivateRoute } from "../app/privateRoute";
import { EmployeeListItemDto } from "../../models/employee/employee";
import { useFetch } from "../../hooks/useFetch";
import { getEmployees } from "../../services/employeeServiceNew";
import { FillingHoursPerSalaryPeriod } from "./fillingHoursPerSalaryPeriod";
import { TESCalculationParameters } from "../../models/calculation/TESCalculationParameters";
import {
    getEmployeeGroupItems,
    getFunctionSettings,
} from "../../services/employeeGroupService";
import { HourBookingCategory } from "../../models/workTime/hourBookingCategory";
import { useTranslation } from "react-i18next";
import { WorkTimeDetailsWorkShiftDateSelect } from "./workTimeDetailsWorkShiftDateSelect";
import { OwnerParameters } from "../../models/owner/ownerParameters";
import { WorkShiftDto } from "../../models/workShift/workShift";
import { getWorkShiftsByTimeRange } from "../../services/workShiftService";
import { showApiError } from "../framework/formUtils";
import { LoadingIndicator } from "../framework/loadingIndicatorNew";
import { fetchPublishedWorkShifts } from "../../store/workShiftPublishedSlice";
import { useAppOptionValueEquals } from "../../hooks/useAppOption";
import { OptionWorkShiftPlanningEnabled } from "../../models/common/consts";
import { fetchGroupedCostCenterOptions } from "../../store/costCenterSlice";
import { fetchVehicleOptions } from "../../store/vehicleSlice";
import { useSelectDailyAllowancesByWorkShiftId } from "../../hooks/workTime/useSelectWorkHours";
import { useWorkTimeDefaultTimezoneForEmployeeGroup } from "../../hooks/useEmployeeGroupOptions";
import { getSalaryPeriodItems } from "../../services/salaryPeriodService";
import { EmployeeGroupItem } from "../../models/employeeGroup/employeeGroupItem";
import { useSelectPublishedWorkShiftsByDate } from "../../hooks/workShiftPlanning/useSelectPublishedWorkShifts";
import { WorkTimeDetailsPlannedShiftCard } from "./workTimeDetailsPlannedShiftCard";

interface IWorkTimeDetailsMainProps {
    backPath: string;
}

export function WorkTimeDetailsMain(
    props: RouteComponentProps & IWorkTimeDetailsMainProps
) {
    const [workShiftsLoaded, setWorkShiftsLoaded] =
        React.useState<boolean>(false);
    const [workShifts, setWorkShifts] = React.useState<WorkShiftDto[]>();
    const [loadingDayBookings, setLoadingDayBookings] =
        React.useState<boolean>(false);
    const { employeeId, date, workShiftId } = useParams<IWorkTimeDetailsPage>();
    const [allEmployeeItems, setAllEmployeeItems] = React.useState<
        EmployeeListItemDto[]
    >([]);
    const [allEmployeeGroupItems, setAllEmployeeGroupItems] =
        useState<EmployeeGroupItem[]>();
    const [allSalaryPeriodItems, setAllSalaryPeriodItems] =
        useState<SalaryPeriodItem[]>();
    const [reloadListKey, reloadList] = useReload();
    const [dayBookingItems, setDayBookingItems] =
        React.useState<DayBookingItemBeta[]>();
    const dispatch = useAppDispatch();
    const [dayBookingTypes, setDayBookingTypes] =
        useState<DayBookingTypeItemBeta[]>();
    const salaryRowTypes = store.useAppSelector(selectSalaryRowTypes);
    const [activeEditor, setActiveEditor] = useState<
        "slots" | "dayBookings" | null
    >(null);
    const [settings, setSettings] = useState<TESCalculationParameters>();
    const [employee, setEmployee] = React.useState<EmployeeListItemDto>();
    const [
        daybookingFillingHourSalaryRowTypeId,
        setDaybookingFillingHourSalaryRowTypeId,
    ] = React.useState(null);
    const { t } = useTranslation();
    const ownerParameters = new OwnerParameters();
    const workShiftEditEnabled =
        ownerParameters.getOptionWorkShiftDateChangeAllowed();
    const [pendingShiftId, setPendingShiftId] = React.useState<string>();
    const [pendingSlotIds, setPendingSlotIds] = React.useState<string[]>();

    const publishedWorkShifts = useSelectPublishedWorkShiftsByDate(
        date,
        date,
        employeeId
    );

    const workShift = React.useMemo(
        () => workShifts?.find((s) => s.workShiftId === workShiftId),
        [workShifts, workShiftId]
    );

    const closestPlannedShift = useMemo(() => {
        if (!workShift || !publishedWorkShifts?.length) return null;

        return publishedWorkShifts.reduce((prev, curr) => {
            const currDiff = Math.abs(
                Base.dayjsDiffInMinutes(workShift.startTime, curr.startTime)
            );
            const prevDiff = Math.abs(
                Base.dayjsDiffInMinutes(workShift.startTime, prev.startTime)
            );
            return currDiff < prevDiff ? curr : prev;
        });
    }, [workShift, publishedWorkShifts]);

    const workShiftTimeSlots = useMemo(
        () => workShift?.workShiftTimeSlots ?? [],
        [workShift?.workShiftTimeSlots]
    );
    const noWorkTimes = workShiftTimeSlots.length === 0;

    const currentDayWorkShifts = React.useMemo(
        () => workShifts?.filter((s) => s.effectiveDate === date),
        [workShifts, date]
    );

    const selectedSalaryPeriodItem = React.useMemo(
        () =>
            allSalaryPeriodItems?.find(
                (i) => i.startDate <= date && i.endDate >= date
            ),
        [allSalaryPeriodItems, date]
    );

    const prevSalaryPeriodItem = React.useMemo(
        () =>
            allSalaryPeriodItems?.find(
                (i) =>
                    i.endDate ===
                    Base.dayjsToJsonDate(Base.dateAddDays(date, -1))
            ),
        [allSalaryPeriodItems, date]
    );

    const nextSalaryPeriodItem = React.useMemo(
        () =>
            allSalaryPeriodItems?.find(
                (i) =>
                    i.startDate ===
                    Base.dayjsToJsonDate(Base.dateAddDays(date, 1))
            ),
        [allSalaryPeriodItems, date]
    );

    useFetch(
        (signal) => getEmployees(null, signal),
        {
            onSuccess: (res) => setAllEmployeeItems(res.data),
        },
        []
    );

    useEffect(() => {
        void getEmployeeGroupItems(1000, 1, "", "name", true).then((data) => {
            setAllEmployeeGroupItems(data.items);
        });
    }, []);

    useEffect(() => {
        if (allEmployeeItems && allEmployeeGroupItems) {
            const selectedEmployee = allEmployeeItems.find(
                (i) => i.id === employeeId
            );
            const selectedEmployeeGroup = allEmployeeGroupItems.find(
                (i) => i.id === selectedEmployee?.salaryGroupId
            );

            if (!!selectedEmployeeGroup?.salaryPeriodTypeId) {
                void getSalaryPeriodItems(
                    selectedEmployeeGroup.salaryPeriodTypeId
                ).then((data) => {
                    setAllSalaryPeriodItems(data);
                });
            }
        }
    }, [allEmployeeItems, allEmployeeGroupItems, employeeId]);

    useEffect(() => {
        if (date && employeeId) {
            const abortController = new AbortController();
            setWorkShiftsLoaded(false);

            getWorkShiftsByTimeRange(
                employeeId,
                date,
                date,
                true,
                abortController.signal
            )
                .then((res) => {
                    setWorkShifts(res);
                })
                .catch((e) => {
                    if (!abortController.signal.aborted) {
                        showApiError(e);
                    }
                })
                .finally(() => setWorkShiftsLoaded(true));

            return () => {
                abortController.abort();
            };
        }
    }, [employeeId, date, reloadListKey]);

    // Navigate to shift of the saved slot using the workShiftId,
    // or deleted slot using the slot ids to find a first matching shift,
    // after shifts have been loaded.
    useEffect(() => {
        if (!!currentDayWorkShifts) {
            let shiftId: string = null;

            if (!!pendingShiftId) {
                shiftId = currentDayWorkShifts.find(
                    (s) => s.workShiftId === pendingShiftId
                )?.workShiftId;

                setPendingShiftId(null);
            } else if (!!pendingSlotIds) {
                shiftId = currentDayWorkShifts.find((s) =>
                    s.workShiftTimeSlots.some((slot) =>
                        pendingSlotIds.includes(slot.id)
                    )
                )?.workShiftId;

                setPendingSlotIds(null);
            }

            if (!!shiftId) {
                customHistory.push(
                    generatePath(props.match.path, {
                        employeeId,
                        date,
                        workShiftId: shiftId,
                    })
                );
            }
        }
    }, [currentDayWorkShifts]);

    const fetchStartDate = Base.dayjsToJsonDate(
        Base.minDate([
            Base.dateStartOf(Base.dateStartOf(date, "month"), "week"),
            selectedSalaryPeriodItem?.startDate,
        ])
    );

    const fetchEndDate = Base.dayjsToJsonDate(
        Base.maxDate([
            Base.dateEndOf(Base.dateEndOf(date, "month"), "week"),
            selectedSalaryPeriodItem?.endDate,
        ])
    );

    const [plannedShiftsEnabled] = useAppOptionValueEquals(
        OptionWorkShiftPlanningEnabled,
        true
    );

    useAsyncThunkAction(
        () =>
            normalWorkHours({
                employeeId,
                startDate: fetchStartDate,
                endDate: fetchEndDate,
            }),
        {},
        [employeeId, fetchStartDate, fetchStartDate, reloadListKey]
    );

    // Load next salary period hours if there is a split work shift at the end of this period
    useAsyncThunkAction(
        () => {
            if (
                !!workShift?.splitAt &&
                workShift.splitAt === nextSalaryPeriodItem?.startDate
            ) {
                return calculatedWorkHours({
                    employeeId,
                    salaryPeriodId: nextSalaryPeriodItem?.id,
                    startDate: nextSalaryPeriodItem?.startDate,
                    endDate: nextSalaryPeriodItem?.endDate,
                });
            }
        },
        {},
        [employeeId, nextSalaryPeriodItem, reloadListKey, workShift?.splitAt]
    );

    // Load prev salary period hours if there is a split work shift at the start of this period
    useAsyncThunkAction(
        () => {
            if (
                workShiftsLoaded &&
                !!workShift?.splitAt &&
                Base.dayjsToJsonDate(
                    Base.dateAddDays(workShift.splitAt, -1)
                ) === prevSalaryPeriodItem?.endDate
            ) {
                return calculatedWorkHours({
                    employeeId,
                    salaryPeriodId: prevSalaryPeriodItem?.id,
                    startDate: prevSalaryPeriodItem?.startDate,
                    endDate: prevSalaryPeriodItem?.endDate,
                });
            }
        },
        {},
        [
            employeeId,
            prevSalaryPeriodItem,
            reloadListKey,
            workShift?.splitAt,
            workShiftsLoaded,
        ]
    );

    useAsyncThunkAction(
        () => {
            if (
                selectedSalaryPeriodItem?.startDate &&
                selectedSalaryPeriodItem?.endDate
            ) {
                return calculatedWorkHours({
                    employeeId,
                    salaryPeriodId: selectedSalaryPeriodItem?.id,
                    startDate: selectedSalaryPeriodItem?.startDate,
                    endDate: selectedSalaryPeriodItem?.endDate,
                });
            }
        },
        {},
        [employeeId, selectedSalaryPeriodItem?.id, reloadListKey]
    );

    useAsyncThunkAction(
        // Used in form and timeline
        () => fetchWorkTimeTypes(),
        { onError: (e) => handleApiError(e, dispatch) },
        []
    );

    const loadDayBookingTypes = async () => {
        try {
            const result = await dayBookingTypeService.getDayBookingTypes();
            setDayBookingTypes(result);
        } catch (error) {
            store.customStore.dispatch(
                storeActions.showErrorMessage(
                    baseService.getErrorMessageFromError(error)
                )
            );
        }
    };

    const loadTesCalculationSettings = () => {
        if (employee) {
            getFunctionSettings(employee.salaryGroupId)
                .then((response) => {
                    setSettings(response);
                })
                .catch(showApiError)
                .finally(() => {});
        }
    };

    useAsyncThunkAction(
        () => fetchSalaryRowTypes(),
        { onError: (e) => handleApiError(e, dispatch) },
        []
    );

    useEffect(() => {
        void loadDayBookingTypes();
    }, []);

    useEffect(() => {
        if (salaryRowTypes) {
            const fillingHourSalaryRowType = salaryRowTypes.find((t) =>
                t.hourBookingCategories.some((c) =>
                    [HourBookingCategory.FillingHour].includes(parseInt(c))
                )
            );
            if (fillingHourSalaryRowType) {
                setDaybookingFillingHourSalaryRowTypeId(
                    fillingHourSalaryRowType.id
                );
            }
        }
    }, [salaryRowTypes]);

    useEffect(() => {
        if (date) {
            const abortController = new AbortController();
            setLoadingDayBookings(true);
            getDayBookingItems(date, date, employeeId, abortController.signal)
                .then((result) => {
                    setDayBookingItems(result);
                })
                .catch((error) => {
                    if (!abortController.signal.aborted) {
                        dispatch(
                            storeActions.showErrorMessage(
                                baseService.getErrorMessageFromError(error)
                            )
                        );
                    }
                })
                .finally(() => {
                    if (!abortController.signal.aborted) {
                        setLoadingDayBookings(false);
                    }
                });
            return () => {
                abortController.abort();
            };
        }
    }, [employeeId, date, reloadListKey]);

    useEffect(() => {
        const selectedEmployee = allEmployeeItems.find(
            (allEmployeeItem) => allEmployeeItem.id === employeeId
        );
        if (selectedEmployee) {
            setEmployee(selectedEmployee);
        }
    }, [employeeId, allEmployeeItems, reloadListKey]);

    useEffect(() => {
        void loadTesCalculationSettings();
    }, [employee?.salaryGroupId, reloadListKey]);

    useAsyncThunkAction(
        () => {
            if (plannedShiftsEnabled && !!fetchStartDate && !!fetchEndDate) {
                return fetchPublishedWorkShifts({
                    startDate: fetchStartDate,
                    endDate: fetchEndDate,
                    employeeIds: employeeId ? [employeeId] : [],
                });
            }
        },
        { onError: showApiError },
        [
            reloadListKey,
            fetchStartDate,
            fetchEndDate,
            employeeId,
            plannedShiftsEnabled,
        ]
    );

    useAsyncThunkAction(
        () => fetchGroupedCostCenterOptions(),
        { onError: showApiError },
        []
    );

    useAsyncThunkAction(
        () => fetchVehicleOptions(),
        { onError: showApiError },
        []
    );

    const calcAllowances = useSelectDailyAllowancesByWorkShiftId(
        employeeId,
        workShiftId
    );

    const shiftDailyAllowances = React.useMemo(
        () =>
            (calcAllowances ?? []).map((a) => ({
                ...a,
                workShiftTimeSlotId:
                    a.workShiftTimeSlotId ?? workShiftTimeSlots[0]?.id,
            })),
        [calcAllowances, workShiftTimeSlots]
    );

    const firstPresentCostCenterId = React.useMemo(
        () => workShiftTimeSlots.map((s) => s.costCenterId).find((id) => id),
        [workShiftTimeSlots]
    );

    const firstPresentVehicleId = React.useMemo(
        () => workShiftTimeSlots.map((s) => s.vehicleId).find((id) => id),
        [workShiftTimeSlots]
    );

    const [defaultTz] = useWorkTimeDefaultTimezoneForEmployeeGroup(
        employeeId,
        allEmployeeItems
    );

    const shiftsToRender = useMemo(() => {
        if (!publishedWorkShifts?.length) {
            return [];
        }

        // no work times → show all planned shifts
        if (noWorkTimes) {
            return publishedWorkShifts;
        }

        // otherwise show only the closest one (if it exists)
        return closestPlannedShift ? [closestPlannedShift] : [];
    }, [noWorkTimes, publishedWorkShifts, closestPlannedShift]);

    if (
        !pendingShiftId &&
        !pendingSlotIds &&
        workShiftsLoaded &&
        currentDayWorkShifts?.length > 0 &&
        !workShift
    ) {
        return (
            <Redirect
                to={generatePath(props.match.path, {
                    employeeId,
                    date,
                    workShiftId: currentDayWorkShifts[0].workShiftId,
                })}
            />
        );
    }

    const noDayBookings =
        dayBookingItems?.length === 0 && shiftDailyAllowances.length === 0;
    const allWorkTimesLocked =
        !noWorkTimes && workShiftTimeSlots.every((slot) => slot.state === 2); // WorkShiftTimeSlotState.Locked

    return date && employeeId && dayBookingItems && dayBookingTypes ? (
        <WorkTimeDetailsLayout
            calendarComponent={
                <WorkTimeDetailsCalendar
                    path={props.match.path}
                    reloadKey={reloadListKey}
                />
            }
            mapComponent={
                noWorkTimes ? null : (
                    <WorkTimeDetailsMap
                        workShiftTimeSlots={workShiftTimeSlots}
                    />
                )
            }
            topComponent={
                <>
                    <Grid2 container columns={36} alignItems="center">
                        <Grid2 xs={1}>
                            <IconButton
                                style={{ backgroundColor: "transparent" }}
                                onClick={() =>
                                    customHistory.push(props.backPath)
                                }
                            >
                                <ArrowBackIcon color="primary" />
                            </IconButton>
                        </Grid2>
                        <Grid2 xs={8} paddingLeft={3}>
                            <MuiSelect
                                label={t("employee.employee")}
                                value={employeeId}
                                options={allEmployeeItems.map((i) => ({
                                    value: i.id,
                                    label: i.fullName,
                                    group: i.salaryGroupName,
                                }))}
                                onChange={(value: string) => {
                                    if (value && value !== employeeId) {
                                        customHistory.push(
                                            generatePath(props.match.path, {
                                                employeeId: value,
                                                date,
                                            })
                                        );
                                    }
                                }}
                            />
                        </Grid2>
                        {workShifts?.length > 0 ? (
                            <Grid2 xs={8} paddingLeft={3}>
                                <MuiSelect
                                    disabled={
                                        workShifts.length === 1 && !!workShift
                                    }
                                    label={t("common.workingTimeRegistration")}
                                    value={workShiftId}
                                    options={workShifts
                                        .map((s) => ({
                                            value: s.workShiftId,
                                            label: `${
                                                s.effectiveDate !== date
                                                    ? Base.dateStrToOriginalTimezoneDateTimeStr(
                                                          s.startTime
                                                      )
                                                    : formatTime(
                                                          s.startTime,
                                                          date
                                                      )
                                            } - ${
                                                !s.endTime
                                                    ? ""
                                                    : s.effectiveDate !== date
                                                      ? Base.dateStrToOriginalTimezoneDateTimeStr(
                                                            s.endTime
                                                        )
                                                      : formatTime(
                                                            s.endTime,
                                                            date
                                                        )
                                            }`,
                                            group: s.effectiveDate,
                                            groupLabel: Base.dayjsToDateStr(
                                                s.effectiveDate
                                            ),
                                            groupLinkPath:
                                                s.effectiveDate === date
                                                    ? null
                                                    : generatePath(
                                                        props.match.path,
                                                        {
                                                            employeeId,
                                                            date: s.effectiveDate,
                                                        }
                                                    ),
                                            disabled: s.effectiveDate !== date,
                                        }))
                                        // Hack to sort current day group as first
                                        .sort((a, b) =>
                                            (a.group === date
                                                ? `0${a.group}`
                                                : a.group
                                            ).localeCompare(
                                                b.group === date
                                                    ? `0${b.group}`
                                                    : b.group
                                            )
                                        )}
                                    onChange={(value: string) => {
                                        if (value && value !== workShiftId) {
                                            customHistory.push(
                                                generatePath(props.match.path, {
                                                    employeeId,
                                                    date,
                                                    workShiftId: value,
                                                })
                                            );
                                        }
                                    }}
                                />
                            </Grid2>
                        ) : null}
                        {!!workShift && workShiftEditEnabled ? (
                            <Grid2 container xs={4} xl={2} paddingLeft={2}>
                                <PrivateRoute
                                    component={
                                        WorkTimeDetailsWorkShiftDateSelect
                                    }
                                    componentProps={{
                                        workShift,
                                        afterSave: reloadList,
                                    }}
                                />
                            </Grid2>
                        ) : null}
                        <Grid2
                            container
                            gap={1}
                            direction="column"
                            xsOffset="auto"
                            alignItems="end"
                        >
                            <Grid2>
                                <WorkHoursPerSalaryPeriod
                                    selectedSalaryPeriodItem={
                                        selectedSalaryPeriodItem
                                    }
                                />
                            </Grid2>
                            {settings?.isFillingHourCalculationOn && (
                                <Grid2>
                                    <FillingHoursPerSalaryPeriod
                                        allEmployeeItems={allEmployeeItems}
                                        selectedSalaryPeriodItem={
                                            selectedSalaryPeriodItem
                                        }
                                        salaryRowTypeId={
                                            daybookingFillingHourSalaryRowTypeId
                                        }
                                    />
                                </Grid2>
                            )}
                            <Grid2>
                                <WorkHoursPerWeek />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </>
            }
            plannedShiftComponent={
                shiftsToRender.length > 0 ? (
                    <WorkTimeDetailsPlannedShiftCard
                        shifts={shiftsToRender}
                        date={date}
                    />
                ) : null
            }
            radioButtonComponent={
                noWorkTimes && noDayBookings ? null : (
                    <DayAllowanceSelect
                        key={`${date}-${employeeId}`}
                        reloadList={reloadList}
                        dayBookingTypes={dayBookingTypes}
                        dayBookingItems={dayBookingItems}
                        allWorkTimesLocked={allWorkTimesLocked}
                        loadingDayBookings={loadingDayBookings}
                        shiftDailyAllowances={shiftDailyAllowances}
                        costCenterId={firstPresentCostCenterId}
                        vehicleId={firstPresentVehicleId}
                        disabled={!!activeEditor}
                    />
                )
            }
            timelineComponent={
                noWorkTimes ? null : (
                    <WorkTimeTimeline
                        reloadList={reloadList}
                        workShiftTimeSlotItems={workShiftTimeSlots}
                        editingDisabled={!!activeEditor}
                    />
                )
            }
            mainComponent={
                <>
                    {!workShiftsLoaded ? <LoadingIndicator /> : null}
                    <WorkTimeDetailsList
                        reloadList={(ids?: string[]) => {
                            if (ids?.length > 0) {
                                setPendingSlotIds(ids);
                            }
                            reloadList();
                        }}
                        workShiftTimeSlotItems={workShiftTimeSlots}
                        defaultTz={defaultTz}
                        editingDisabled={activeEditor === "dayBookings"}
                        onEditingChange={(editing) =>
                            setActiveEditor(editing ? "slots" : null)
                        }
                    />
                </>
            }
            bottomComponent={
                <WorkTimeDetailsDayBookingList
                    reloadList={reloadList}
                    dayBookingItems={dayBookingItems}
                    dayBookingTypes={dayBookingTypes}
                    shiftDailyAllowances={shiftDailyAllowances}
                    shiftCostCenterId={firstPresentCostCenterId}
                    shiftVehicleId={firstPresentVehicleId}
                    editingDisabled={activeEditor === "slots"}
                    onEditingChange={(editing) =>
                        setActiveEditor(editing ? "dayBookings" : null)
                    }
                />
            }
        />
    ) : (
        <div>{t("common.loading")}...</div>
    );
}
